import React from "react";
import { Col, Form } from "react-bootstrap";

export interface SwitchFieldProps {
  label: string;
  checked: boolean;
  colSize?: number;
  isEditable?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({
  label,
  checked,
  colSize = 6,
  isEditable = false,
  onChange,
}) => (
  <Col xs={12} md={colSize}>
    <Form.Group className="mb-3">
      <Form.Check
        type="switch"
        label={label}
        className="mt-2"
        checked={checked}
        readOnly={!isEditable}
        disabled={!isEditable}
        onChange={isEditable ? onChange : undefined}
      />
    </Form.Group>
  </Col>
);

export default SwitchField;
